(function ($) {
  // Set all elements in reference-carousel as same height
  // Get an array of all element heights

  $(document).ready(function () {
    const elementHeights = $(".brand-ingress")
      .map(function () {
        return $(this).height();
      })
      .get();

    // Math.max takes a variable number of arguments
    // `apply` is equivalent to passing each height as an argument
    const maxHeight = Math.max.apply(null, elementHeights);

    // Set each height to the max height
    $(".brand-ingress").height(maxHeight);
  });

  // Conditionally hide vaihtovene fields
  $("#billing_vaihtovene_a_field").hide();
  $("#billing_vaihtovene_b_field").hide();
  $("#billing_vaihtovene_c_field").hide();
  $("#billing_vaihtovene_d_field").hide();
  $("#billing_vaihtovene_e_field").hide();
  $("#billing_vaihtovene_f_field").hide();
  $("#billing_vaihtovene_g_field").hide();

  $("input#billing_vaihtovene").change(function () {
    if (this.checked) {
      $("#billing_vaihtovene_a_field").fadeIn();
      $("#billing_vaihtovene_b_field").fadeIn();
      $("#billing_vaihtovene_c_field").fadeIn();
      $("#billing_vaihtovene_d_field").fadeIn();
      $("#billing_vaihtovene_e_field").fadeIn();
      $("#billing_vaihtovene_f_field").fadeIn();
      $("#billing_vaihtovene_g_field").fadeIn();
    } else {
      $("#billing_vaihtovene_a_field").fadeOut();
      $("#billing_vaihtovene_b_field").fadeOut();
      $("#billing_vaihtovene_c_field").fadeOut();
      $("#billing_vaihtovene_d_field").fadeOut();
      $("#billing_vaihtovene_e_field").fadeOut();
      $("#billing_vaihtovene_f_field").fadeOut();
      $("#billing_vaihtovene_g_field").fadeOut();
    }
  });
})(jQuery);

// This filter is run for composite products.
(function ($, window, document, undefined) {
  $(".composite_data").on(
    "wc-composite-initializing",
    function (event, composite) {},
  );
})(jQuery, window, document);
